// prettier-ignore
const template = (data) => {
    return `<div class="checkbox checkbox--island">
    <input type="checkbox" class="checkbox__input" id="quiz-${data.id}" name="answer[]" data-element="input" value="${data.id}">
    <label for="quiz-${data.id}" class="checkbox__label">${data.answerText}</label>
</div>`
}
export default template
